import { Coverage, Package } from '../interfaces/interfaces';
import { uppercaseFirst } from './shared';
import { Link } from 'react-router-dom';
import track from 'c9-tracking';

const coverageOrder: Record<string, string[]> = {
    CAR: [
        'ROAD_ASSISTANCE',
        'PARKING_DAMAGE',
        'DEDUCTIBLE_COVER',
        'WINDSCREEN_PROTECTION',
        'DRIVERS_ACCIDENT',
        'COMPREHENSIVE',
        'LIABILITY'
    ],
    CHILD: [
        'SUDDEN_DAMAGE',
        'IMMEDIATE_COMPENSATION_CRITICAL_DISEASES',
        'PERMANENT_INJURY_AFTER_CERTAIN_CRITICAL_DISEASES',
        'FUNERAL_SUPPORT',
        'GLASSES',
        'TOOTH_AND_CHEWING_DAMAGE',
        'REHABILITATION',
        'PERMANENT_INJURY_AFTER_ACCIDENT'
    ]
};

export const mappedPackages = (packagesRaw: Package[]) => {
    return packagesRaw.map((p: Package) => {
        return {
            id: p.quoteId,
            //name: capitalize(p.packageName.toLowerCase()),
            //price: `${p.monthlyPrice} kr./md`,
            // These a switch to accommodate the layout
            price: uppercaseFirst(p.packageName),
            name: `${p.monthlyPrice} kr./md`,
            coveredCoverageIds: p.coverages
                .filter((c: Coverage) => c.showInPackage && c.selected)
                .map((coverage: Coverage) => coverage.coverageId.toString())
        };
    });
};

const flatCoverages = (packagesRaw: Package[]): FlatCoverage[] => {
    return packagesRaw
        .map((p: Package) => {
            return p.coverages.map((coverage: Coverage) => {
                return {
                    ...coverage,
                    id: coverage.coverageId.toString(),
                    info: (
                        <Link
                            onClick={() =>
                                track.interact([{ key: 'clicked-coverage-info-link', value: coverage.name }])
                            }
                            to={`/pakker/daekning/${coverage.coverageId}`}
                        >
                            Info
                        </Link>
                    )
                };
            });
        })
        .flat();
};

type FlatCoverage = {
    id: string;
    info: React.JSX.Element;
    coverageAlias: string;
    coverageId: number;
    deductableAmount: number;
    deductableBasis: number;
    name: string;
    selected: boolean;
    showInPackage: boolean;
    enabled?: boolean;
};

export const uniqueSelectorCoverages = (packagesRaw: Package[], product: string): FlatCoverage[] => {
    const fc = flatCoverages(packagesRaw);
    const selectorCoverages = fc.filter((fc: FlatCoverage) => fc.selected && fc.showInPackage);

    const unique = selectorCoverages.filter(
        (item: FlatCoverage, index: number) =>
            selectorCoverages.findIndex((item2: FlatCoverage) => item2.coverageId === item.coverageId) === index
    );
    return unique.sort(
        (a: FlatCoverage, b: FlatCoverage) =>
            coverageOrder[product].indexOf(a.coverageAlias) - coverageOrder[product].indexOf(b.coverageAlias)
    );
};

/*
    Validate payload cor car before ceeating packages
*/
type Payload = {
    productKey: string;
    yearlyMileage: number;
    ownCarYears: number;
    numberOfClaims: number;
    leasingCar: boolean;
    kvhxKey?: string; // when NOT logged in
    cprNo?: string; // when NOT logged in
    registrationNumber?: string; // using number plate
    viNumber?: string; // using viNumber
    variantId?: number; // using maker-model
    alreadyCovered?: boolean; // do not belong to car
};
export const validateCarPackagePayload = (payload: Payload, isLoggedIn: boolean) => {
    const {
        productKey,
        yearlyMileage,
        ownCarYears,
        numberOfClaims,
        leasingCar,
        kvhxKey,
        cprNo,
        registrationNumber,
        viNumber,
        variantId
    } = payload;

    const preConditions: boolean = (productKey &&
        yearlyMileage > 0 &&
        ownCarYears >= 0 &&
        numberOfClaims >= 0 &&
        leasingCar !== undefined &&
        (registrationNumber || viNumber || variantId! > 0)) as boolean;

    if (isLoggedIn && preConditions) {
        return true;
    }

    if (preConditions && kvhxKey && cprNo) {
        return true;
    }

    return false;
};
